import { useTranslation } from 'react-i18next'

import { Tip, useTip } from '@makyoapp/makyo-ui'

interface FormErrorBadgeProps {
  errorType: string
}

// FormErrorBadge component is created to show a tooltip with an error message when hovering over it.
function FormErrorBadge({ errorType }: FormErrorBadgeProps) {
  // useTip hook from makyo-ui is used to handle the tooltip behavior
  const {
    x,
    y,
    strategy,
    refs,
    context,
    placement,
    isOpen: isTipOpen,
    arrowRef,
    getReferenceProps,
    getFloatingProps,
  } = useTip()

  const { t } = useTranslation()

  const errorMessage = errorType
    ? {
        'no-container': t(
          'The form components must be placed inside a form container. Kindly drag and drop this component into the form container'
        ),
        'duplicate-column': t(
          'Multiple elements are referencing the same column. Please ensure each form element has a unique column.'
        ),
        'no-column': t(
          'This form element is not connected to any column. To fix this, go to Data > Column and select one.'
        ),
      }[errorType]
    : null

  if (!errorMessage) return null

  return (
    <div className='flex-cc w-9 h-9'>
      <span
        ref={refs.setReference}
        className='cursor-pointer text-m-sm flex-cc rounded-full w-4.5 h-4.5 bg-red-600 dark:bg-red-400 text-white font-bold'
        {...getReferenceProps()}
      >
        !
      </span>

      {isTipOpen && (
        <Tip
          className='max-w-[300px] text-m-m'
          x={x}
          y={y}
          placement={placement}
          strategy={strategy}
          ref={refs.setFloating}
          {...getFloatingProps()}
          context={context as any}
          arrowRef={arrowRef}
        >
          {errorMessage}
        </Tip>
      )}
    </div>
  )
}

export default FormErrorBadge
